import React from 'react'
import MatrixEventTile, {
  haveTileForEvent,
  setTileHandler,
  getHandlerTile,
} from 'matrix-react-sdk/lib/components/views/rooms/EventTile'

const infoMessageExclusionTypes = [
  'm.room.message',
  'm.sticker',
  'm.room.create',
]
const EventTile = ({ readMarkerVisible, ...props }) => {
  return (
    <MatrixEventTile
      {...props} // eslint-disable-line react/jsx-props-no-spreading
      avatarPosition="wrapper"
      messageOverlayPosition="content"
      showSenderAvatar
      infoMessageExclusionTypes={infoMessageExclusionTypes}
    />
  )
}

EventTile.haveTileForEvent = haveTileForEvent
EventTile.setTileHandler = setTileHandler
EventTile.getHandlerTile = getHandlerTile
export default EventTile
